import { useParams } from 'react-router-dom';
import type { PublicMapRouteParams } from '~/_shared/constants/routes';
import { ExportReportType } from '~/exportReport/exportReportType';
import { ExportReportLocationPrintPageComponent } from '~/exportReport/printPage/exportReportLocationPrintPage.component';
import { useToolsStateExportReportSelector } from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.selectors';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';

export const ExportReportPrintPageContainer = () => {
  const { mapShareId = '' } = useParams<PublicMapRouteParams>();
  const mapId = useMapIdSelector();
  const exportReportState = useToolsStateExportReportSelector();

  if (!exportReportState.isActive) {
    return null;
  }

  if (exportReportState.params.type === ExportReportType.Location) {
    return (
      <ExportReportLocationPrintPageComponent
        mapId={mapId}
        mapShareId={mapShareId}
        params={exportReportState.params}
        template={exportReportState.template}
      />
    );
  }

  return null;
};
